import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import AlertMessage from "../../../components/alertmessage/AlertMessage";
import { CalibrateCard } from "../../../components/cards/calibratecard/CalibrateCard";
import { FileBrowserCard } from "../../../components/cards/filebrowsercard/FileBrowserCard";
import { InstallCard } from "../../../components/cards/installcard/InstallCard";
import { TerminalCard } from "../../../components/cards/terminalcard/TerminalCard";
import { WiFiCard } from "../../../components/cards/wificard/WiFiCard";
import { StackTraceDecoderCard } from "../../../components/cards/stacktracedecodercard/StackTraceDecoderCard";
import LogModal from "../../../modals/logmodal/LogModal";
import PageTitle from "../../../components/pagetitle/PageTitle";
import { ControllerServiceContext } from "../../../context/ControllerServiceContext";
import usePageView from "../../../hooks/usePageView";
import Page from "../../../model/Page";
import "./Home.scss";

const Home = () => {
    usePageView("Home");
    const { t } = useTranslation();
    const navigate = useNavigate();
    const controllerService = useContext(ControllerServiceContext);
    const [showLogModal, setShowLogModal] = useState<boolean>(false);

    return (
        <>
            <LogModal
                show={showLogModal}
                setShow={setShowLogModal}
                rows={controllerService.startupLines}
            />
            <div className="content-stack">
                <section className="surface-panel page-hero home-hero">
                    <span className="page-kicker">{t("page.connection.title")}</span>
                    <PageTitle>{t("page.connection.title")}</PageTitle>
                    <p className="page-subtitle">{t("page.home.description")}</p>
                </section>

                <Row>
                    <Col xs={12}>
                        {controllerService.hasErrors && (
                            <AlertMessage variant="danger">
                                {t("page.home.error-while-booting")}
                                <br />
                                <a
                                    href="#"
                                    onClick={() => setShowLogModal(true)}
                                >
                                    {t("page.home.show-details")}
                                </a>
                            </AlertMessage>
                        )}
                    </Col>
                </Row>

                <div className="surface-panel panel-section select-panel">
                    <Row className="select-grid g-4">
                    <Col xs={12} md={6} lg={4} className="d-flex">
                        <InstallCard
                            onClick={() => navigate(Page.FLUIDNC_INSTALLER)}
                        />
                    </Col>
                    <Col xs={12} md={6} lg={4} className="d-flex">
                        <TerminalCard
                            disabled={false}
                            onClick={() => navigate(Page.FLUIDNC_TERMINAL)}
                        />
                    </Col>
                    {controllerService.version && (
                        <Col xs={12} md={6} lg={4} className="d-flex">
                            <FileBrowserCard
                                onClick={() =>
                                    navigate(Page.FLUIDNC_FILEBROWSER)
                                }
                            />
                        </Col>
                    )}
                    {controllerService.version && (
                        <Col xs={12} md={6} lg={4} className="d-flex">
                            <CalibrateCard
                                onClick={() => navigate(Page.FLUIDNC_CALIBRATE)}
                            />
                        </Col>
                    )}
                    {controllerService.hasWiFi && (
                        <Col xs={12} md={6} lg={4} className="d-flex">
                            <WiFiCard
                                onClick={() => navigate(Page.FLUIDNC_WIFI)}
                            />
                        </Col>
                    )}
                    <Col xs={12} md={6} lg={4} className="d-flex">
                        <StackTraceDecoderCard
                            onClick={() =>
                                navigate(Page.FLUIDNC_STACKTRACE_DECODER)
                            }
                        />
                    </Col>
                    {/* false && (
                    <Col xs={12} md={6} lg={4}>
                        <LogModal
                            show={showLogModal}
                            setShow={setShowLogModal}
                            rows={controllerService.startupLines}
                        />
                    </Col>
                    )*/}
                    </Row>
                </div>
            </div>
        </>
    );
};

export default Home;
